// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-gradient-card-collection[data-v-e3d9827a]:after{background:radial-gradient(circle at 5% 95%,rgba(0,79,89,.3) 0,transparent 90%),radial-gradient(circle at 95% 5%,rgba(0,79,89,.1) 0,transparent 50%);bottom:0;content:\"\";display:block;height:100%;left:0;position:absolute;width:100%;z-index:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
